import { request } from "../network/request";
const db = "dn0";
//查询任务类型列表

export function deletejudges(id) {
    return request({
        url: "course/judges/remove",
        method: "get",
        params: {
            db,
            id
        },
    });
}

export function list(params, page, pageSize) {
    return request({
        url: "course/judges/list",
        method: "post",
        data: params,
        params: {
            page,
            pageSize
        }
    });
}

export function judgesAdd(params) {
    return request({
        url: "course/judges/add",
        method: "post",
        data: params,
    });
}

export function editJudges(params) {
    return request({
        url: "course/judges/editJudges",
        method: "post",
        data: params,
    });
}